import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SpinnerService } from '../../../services/spinner.service';
import { TransferService } from '../../../services/transfer.service';
import { CategoryService } from '../../../services/category.service';

@Component({
    selector: 'app-transfer-edit',
    templateUrl: './transfer-edit.component.html',
    styleUrls: ['./transfer-edit.component.css']
})
export class TransferEditComponent implements OnInit {
    transfId: number;
    amount_multiplier: number = 1;
    transfer = {
        date: new Date().toISOString().slice(0, 10),
        amount: 0,
        name: '',
        comment: '',
        stmt: null,
        category: null,
        recurrent: null,
        done: false,
    };
    categories: any[] = [];

    constructor(private route: ActivatedRoute,
        private router: Router,
        private spinner: SpinnerService,
        private transferService: TransferService,
        private categoryService: CategoryService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.transfId = +params['id'];
            this.getTransfer();
            this.getCategories();
        });
    }

    getTransfer() {
        this.spinner.startLoad('transfer-edit-getTransfer');
        this.transferService.getTransfer(this.transfId).subscribe(
            (res) => this.formatTransfer(res),
            (err) => console.error(err),
            () => this.spinner.finishLoad('transfer-edit-getTransfer')
        );
    }

    getCategories() {
        this.spinner.startLoad('transfer-edit-getCategories');
        this.categoryService.getCategories().subscribe(
            (res) => this.categories = res,
            (err) => console.error(err),
            () => this.spinner.finishLoad('transfer-edit-getCategories')
        );
    }

    formatTransfer(transfer) {
        this.transfer = transfer;

        this.transfer.date = transfer.date.slice(0, 10);
        this.amount_multiplier = this.transfer.amount < 0 ? -1 : 1;
        this.transfer.amount = this.transfer.amount * this.amount_multiplier;
    }

    saveTransfer() {
        this.transfer.amount = this.transfer.amount * this.amount_multiplier;
        this.spinner.startLoad('transfer-edit-saveTransfer');
        this.transferService.updateTransfer(this.transfer).subscribe(
            (res) => this.router.navigate(['/statement', res]),
            (err) => console.error(err),
            () => this.spinner.finishLoad('transfer-edit-saveTransfer')
        );
    }

    deleteTransfer() {
        this.spinner.startLoad('transfer-edit-saveTransfer');
        this.transferService.deleteTransfer(this.transfer).subscribe(
            (res) => this.router.navigate(['/statement', res]),
            (err) => console.error(err),
            () => this.spinner.finishLoad('transfer-edit-saveTransfer')
        );
    }
}
